import get from "lodash/get";

function getCsId (main: any) {
  return get(main, "tenant.supportAccountId", undefined);
}

export default getCsId;
